import classNames from 'classnames';
import React from 'react';

type LinkButtonProps = {
  text: string;
  onClick: React.MouseEventHandler<HTMLSpanElement>;
  className?: string;
  thin?: boolean;
};

const TextButton = ({ text, onClick, className, thin = false }: LinkButtonProps) => {
  const classes = classNames('underline clickable', className, {
    'font-bold': !thin,
    'font-normal': thin
  });

  return (
    <span onClick={onClick} className={classes}>
      {text}
    </span>
  );
};

export default TextButton;
